import { render, staticRenderFns } from "./ListTag.vue?vue&type=template&id=6b55cff4&"
import script from "./ListTag.vue?vue&type=script&lang=js&"
export * from "./ListTag.vue?vue&type=script&lang=js&"
import style0 from "./ListTag.vue?vue&type=style&index=0&id=6b55cff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports